import toError from './toError';

const isLocalDevEnvironment = Boolean(process.env.IS_LOCAL);

class ErrorWithContext extends Error {
  context: Record<string, any>;

  error: Error;

  constructor(error: unknown, context: Record<string, any>) {
    super();
    this.error = toError(error);
    this.context = {
      pod: isLocalDevEnvironment
        ? 'local'
        : process.env.MY_POD_NAME ?? 'unknown',
      ...context
    };
  }

  get message() {
    return this.error.message;
  }

  get stack() {
    return this.error.stack;
  }
}

export default ErrorWithContext;
